import i18n from './index';
import { fixedUi } from './fixedUi';

/**
 * 设计模板 / 商品规格里的颜色名（存库为中文，展示时按当前语言翻译）。
 * 数据层仍用中文 key，禁止把翻译结果写回 colorLabel。
 */
const COLOR_NAMES = {
  黑色: { en: 'Black', 'pt-BR': 'Preto', es: 'Negro', de: 'Schwarz', fr: 'Noir', it: 'Nero', ja: 'ブラック', ko: '블랙', th: 'สีดำ', vi: 'Đen', id: 'Hitam' },
  白色: { en: 'White', 'pt-BR': 'Branco', es: 'Blanco', de: 'Weiß', fr: 'Blanc', it: 'Bianco', ja: 'ホワイト', ko: '화이트', th: 'สีขาว', vi: 'Trắng', id: 'Putih' },
  米白色: { en: 'Off-white', 'pt-BR': 'Branco off', es: 'Blanco roto', de: 'Off-White', fr: 'Blanc cassé', it: 'Bianco panna', ja: 'オフホワイト', ko: '오프화이트', th: 'สีขาวนวล', vi: 'Trắng ngà', id: 'Putih gading' },
  奶白色: { en: 'Cream white', 'pt-BR': 'Branco creme', es: 'Blanco crema', de: 'Cremeweiß', fr: 'Blanc crème', it: 'Bianco crema', ja: 'クリームホワイト', ko: '크림 화이트', th: 'สีขาวครีม', vi: 'Trắng kem', id: 'Putih krem' },
  米色: { en: 'Beige', 'pt-BR': 'Bege', es: 'Beige', de: 'Beige', fr: 'Beige', it: 'Beige', ja: 'ベージュ', ko: '베이지', th: 'สีเบจ', vi: 'Be', id: 'Beige' },
  燕麦色: { en: 'Oatmeal', 'pt-BR': 'Aveia', es: 'Avena', de: 'Hafer', fr: 'Avoine', it: 'Avena', ja: 'オートミール', ko: '오트밀', th: 'สีข้าวโอ๊ต', vi: 'Yến mạch', id: 'Oatmeal' },
  灰色: { en: 'Gray', 'pt-BR': 'Cinza', es: 'Gris', de: 'Grau', fr: 'Gris', it: 'Grigio', ja: 'グレー', ko: '그레이', th: 'สีเทา', vi: 'Xám', id: 'Abu-abu' },
  深灰色: { en: 'Dark gray', 'pt-BR': 'Cinza escuro', es: 'Gris oscuro', de: 'Dunkelgrau', fr: 'Gris foncé', it: 'Grigio scuro', ja: 'ダークグレー', ko: '다크 그레이', th: 'สีเทาเข้ม', vi: 'Xám đậm', id: 'Abu-abu tua' },
  浅灰色: { en: 'Light gray', 'pt-BR': 'Cinza claro', es: 'Gris claro', de: 'Hellgrau', fr: 'Gris clair', it: 'Grigio chiaro', ja: 'ライトグレー', ko: '라이트 그레이', th: 'สีเทาอ่อน', vi: 'Xám nhạt', id: 'Abu-abu muda' },
  红色: { en: 'Red', 'pt-BR': 'Vermelho', es: 'Rojo', de: 'Rot', fr: 'Rouge', it: 'Rosso', ja: 'レッド', ko: '레드', th: 'สีแดง', vi: 'Đỏ', id: 'Merah' },
  酒红色: { en: 'Wine', 'pt-BR': 'Vinho', es: 'Vino', de: 'Weinrot', fr: 'Bordeaux', it: 'Bordeaux', ja: 'ワイン', ko: '와인', th: 'สีไวน์', vi: 'Đỏ rượu', id: 'Merah anggur' },
  粉色: { en: 'Pink', 'pt-BR': 'Rosa', es: 'Rosa', de: 'Rosa', fr: 'Rose', it: 'Rosa', ja: 'ピンク', ko: '핑크', th: 'สีชมพู', vi: 'Hồng', id: 'Merah muda' },
  豆沙粉: { en: 'Dusty pink', 'pt-BR': 'Rosa acinzentado', es: 'Rosa empolvado', de: 'Altrosa', fr: 'Rose poudré', it: 'Rosa antico', ja: 'くすみピンク', ko: '더스티 핑크', th: 'สีชมพูหม่น', vi: 'Hồng đất', id: 'Merah muda kusam' },
  橙色: { en: 'Orange', 'pt-BR': 'Laranja', es: 'Naranja', de: 'Orange', fr: 'Orange', it: 'Arancione', ja: 'オレンジ', ko: '오렌지', th: 'สีส้ม', vi: 'Cam', id: 'Oranye' },
  黄色: { en: 'Yellow', 'pt-BR': 'Amarelo', es: 'Amarillo', de: 'Gelb', fr: 'Jaune', it: 'Giallo', ja: 'イエロー', ko: '옐로', th: 'สีเหลือง', vi: 'Vàng', id: 'Kuning' },
  绿色: { en: 'Green', 'pt-BR': 'Verde', es: 'Verde', de: 'Grün', fr: 'Vert', it: 'Verde', ja: 'グリーン', ko: '그린', th: 'สีเขียว', vi: 'Xanh lá', id: 'Hijau' },
  军绿色: { en: 'Army green', 'pt-BR': 'Verde militar', es: 'Verde militar', de: 'Armeegrün', fr: 'Vert militaire', it: 'Verde militare', ja: 'アーミーグリーン', ko: '밀리터리 그린', th: 'สีเขียวทหาร', vi: 'Xanh quân đội', id: 'Hijau army' },
  墨绿色: { en: 'Dark green', 'pt-BR': 'Verde escuro', es: 'Verde oscuro', de: 'Dunkelgrün', fr: 'Vert foncé', it: 'Verde scuro', ja: 'ダークグリーン', ko: '다크 그린', th: 'สีเขียวเข้ม', vi: 'Xanh đậm', id: 'Hijau tua' },
  蓝色: { en: 'Blue', 'pt-BR': 'Azul', es: 'Azul', de: 'Blau', fr: 'Bleu', it: 'Blu', ja: 'ブルー', ko: '블루', th: 'สีฟ้า', vi: 'Xanh dương', id: 'Biru' },
  深蓝色: { en: 'Navy', 'pt-BR': 'Azul-marinho', es: 'Azul marino', de: 'Marineblau', fr: 'Bleu marine', it: 'Blu navy', ja: 'ネイビー', ko: '네이비', th: 'สีน้ำเงินเข้ม', vi: 'Xanh navy', id: 'Biru navy' },
  浅蓝色: { en: 'Light blue', 'pt-BR': 'Azul-claro', es: 'Azul claro', de: 'Hellblau', fr: 'Bleu clair', it: 'Azzurro', ja: 'ライトブルー', ko: '라이트 블루', th: 'สีฟ้าอ่อน', vi: 'Xanh dương nhạt', id: 'Biru muda' },
  天蓝色: { en: 'Sky blue', 'pt-BR': 'Azul-céu', es: 'Azul cielo', de: 'Himmelblau', fr: 'Bleu ciel', it: 'Azzurro cielo', ja: 'スカイブルー', ko: '스카이 블루', th: 'สีฟ้า', vi: 'Xanh trời', id: 'Biru langit' },
  藏青色: { en: 'Navy', 'pt-BR': 'Azul-marinho', es: 'Azul marino', de: 'Marineblau', fr: 'Bleu marine', it: 'Blu navy', ja: 'ネイビー', ko: '네이비', th: 'สีกรมท่า', vi: 'Xanh than', id: 'Biru dongker' },
  宝蓝色: { en: 'Royal blue', 'pt-BR': 'Azul-royal', es: 'Azul real', de: 'Königsblau', fr: 'Bleu roi', it: 'Blu royal', ja: 'ロイヤルブルー', ko: '로열 블루', th: 'สีน้ำเงินรอยัล', vi: 'Xanh hoàng gia', id: 'Biru royal' },
  青色: { en: 'Cyan', 'pt-BR': 'Ciano', es: 'Cian', de: 'Türkis', fr: 'Cyan', it: 'Ciano', ja: 'シアン', ko: '시안', th: 'สีฟ้าอมเขียว', vi: 'Xanh cyan', id: 'Sian' },
  紫色: { en: 'Purple', 'pt-BR': 'Roxo', es: 'Morado', de: 'Lila', fr: 'Violet', it: 'Viola', ja: 'パープル', ko: '퍼플', th: 'สีม่วง', vi: 'Tím', id: 'Ungu' },
  棕色: { en: 'Brown', 'pt-BR': 'Marrom', es: 'Marrón', de: 'Braun', fr: 'Marron', it: 'Marrone', ja: 'ブラウン', ko: '브라운', th: 'สีน้ำตาล', vi: 'Nâu', id: 'Cokelat' },
  咖啡色: { en: 'Coffee', 'pt-BR': 'Café', es: 'Café', de: 'Kaffeebraun', fr: 'Café', it: 'Caffè', ja: 'コーヒー', ko: '커피', th: 'สีน้ำตาลกาแฟ', vi: 'Nâu cà phê', id: 'Cokelat kopi' },
  卡其色: { en: 'Khaki', 'pt-BR': 'Cáqui', es: 'Caqui', de: 'Khaki', fr: 'Kaki', it: 'Kaki', ja: 'カーキ', ko: '카키', th: 'สีกากี', vi: 'Kaki', id: 'Khaki' },
  杏色: { en: 'Apricot', 'pt-BR': 'Damasco', es: 'Albaricoque', de: 'Aprikose', fr: 'Abricot', it: 'Albicocca', ja: 'アプリコット', ko: '살구색', th: 'สีแอปริคอท', vi: 'Mơ', id: 'Aprikot' },
  驼色: { en: 'Camel', 'pt-BR': 'Camelo', es: 'Camel', de: 'Kamel', fr: 'Camel', it: 'Cammello', ja: 'キャメル', ko: '카멜', th: 'สีอูฐ', vi: 'Lạc đà', id: 'Camel' },
  裸色: { en: 'Nude', 'pt-BR': 'Nude', es: 'Nude', de: 'Nude', fr: 'Nude', it: 'Nude', ja: 'ヌード', ko: '누드', th: 'สีเนื้อ', vi: 'Nude', id: 'Nude' },
  金色: { en: 'Gold', 'pt-BR': 'Dourado', es: 'Dorado', de: 'Gold', fr: 'Or', it: 'Oro', ja: 'ゴールド', ko: '골드', th: 'สีทอง', vi: 'Vàng kim', id: 'Emas' },
  银色: { en: 'Silver', 'pt-BR': 'Prateado', es: 'Plateado', de: 'Silber', fr: 'Argent', it: 'Argento', ja: 'シルバー', ko: '실버', th: 'สีเงิน', vi: 'Bạc', id: 'Perak' },
  玫瑰金: { en: 'Rose gold', 'pt-BR': 'Ouro rosa', es: 'Oro rosa', de: 'Roségold', fr: 'Or rose', it: 'Oro rosa', ja: 'ローズゴールド', ko: '로즈 골드', th: 'สีโรสโกลด์', vi: 'Vàng hồng', id: 'Emas mawar' },
  香槟色: { en: 'Champagne', 'pt-BR': 'Champanhe', es: 'Champán', de: 'Champagner', fr: 'Champagne', it: 'Champagne', ja: 'シャンパン', ko: '샴페인', th: 'สีแชมเปญ', vi: 'Sâm panh', id: 'Champagne' },
  透明: { en: 'Transparent', 'pt-BR': 'Transparente', es: 'Transparente', de: 'Transparent', fr: 'Transparent', it: 'Trasparente', ja: 'クリア', ko: '투명', th: 'สีใส', vi: 'Trong suốt', id: 'Transparan' },
  花色: { en: 'Floral', 'pt-BR': 'Estampado', es: 'Estampado', de: 'Gemustert', fr: 'À motifs', it: 'Fantasia', ja: '柄', ko: '패턴', th: 'สีลายดอก', vi: 'Họa tiết', id: 'Motif' },
  多色: { en: 'Multicolor', 'pt-BR': 'Multicolor', es: 'Multicolor', de: 'Mehrfarbig', fr: 'Multicolore', it: 'Multicolore', ja: 'マルチカラー', ko: '멀티컬러', th: 'หลากสี', vi: 'Đa màu', id: 'Multicolor' },
  玫红色: { en: 'Rose red', 'pt-BR': 'Rosa intenso', es: 'Rosa intenso', de: 'Intensivrosa', fr: 'Rose vif', it: 'Rosa intenso', ja: 'ローズレッド', ko: '로즈 레드', th: 'สีแดงกุหลาบ', vi: 'Hồng đậm', id: 'Merah mawar' },
  藕粉色: { en: 'Lotus pink', 'pt-BR': 'Rosa lótus', es: 'Rosa loto', de: 'Lotusrosa', fr: 'Rose lotus', it: 'Rosa loto', ja: 'ロータスピンク', ko: '로터스 핑크', th: 'สีชมพูบัว', vi: 'Hồng sen', id: 'Merah muda lotus' },
  香芋紫: { en: 'Taro purple', 'pt-BR': 'Lilás taro', es: 'Lila taro', de: 'Tarolila', fr: 'Lilas taro', it: 'Lilla taro', ja: 'タローパープル', ko: '타로 퍼플', th: 'สีม่วงเผือก', vi: 'Tím khoai môn', id: 'Ungu talas' },
  雾霾蓝: { en: 'Haze blue', 'pt-BR': 'Azul acinzentado', es: 'Azul grisáceo', de: 'Graublau', fr: 'Bleu grisé', it: 'Blu grigio', ja: 'くすみブルー', ko: '더스티 블루', th: 'สีฟ้าหม่น', vi: 'Xanh khói', id: 'Biru kabut' },
  湖蓝色: { en: 'Lake blue', 'pt-BR': 'Azul turquesa', es: 'Azul turquesa', de: 'Türkisblau', fr: 'Bleu turquoise', it: 'Blu turchese', ja: 'ターコイズブルー', ko: '터키 블루', th: 'สีฟ้าคราม', vi: 'Xanh hồ', id: 'Biru danau' },
  牛仔蓝: { en: 'Denim blue', 'pt-BR': 'Azul jeans', es: 'Azul denim', de: 'Jeansblau', fr: 'Bleu jean', it: 'Blu denim', ja: 'デニムブルー', ko: '데님 블루', th: 'สีฟ้าดีนิม', vi: 'Xanh denim', id: 'Biru denim' },
  荧光绿: { en: 'Fluorescent green', 'pt-BR': 'Verde fluorescente', es: 'Verde fluorescente', de: 'Neongrün', fr: 'Vert fluo', it: 'Verde fluorescente', ja: '蛍光グリーン', ko: '형광 그린', th: 'สีเขียวเรืองแสง', vi: 'Xanh neon', id: 'Hijau neon' },
  枣红色: { en: 'Burgundy', 'pt-BR': 'Vermelho bordô', es: 'Rojo burdeos', de: 'Burgunderrot', fr: 'Rouge bordeaux', it: 'Rosso bordeaux', ja: 'バーガンディ', ko: '버건디', th: 'สีแดงเบอร์กันดี', vi: 'Đỏ burgundy', id: 'Merah burgundy' },
  奶黄色: { en: 'Cream yellow', 'pt-BR': 'Amarelo creme', es: 'Amarillo crema', de: 'Cremegelb', fr: 'Jaune crème', it: 'Giallo crema', ja: 'クリームイエロー', ko: '크림 옐로', th: 'สีเหลืองครีม', vi: 'Vàng kem', id: 'Kuning krem' },
  大象灰: { en: 'Elephant gray', 'pt-BR': 'Cinza elefante', es: 'Gris elefante', de: 'Elefantengrau', fr: 'Gris éléphant', it: 'Grigio elefante', ja: 'エレファントグレー', ko: '엘리펀트 그레이', th: 'สีเทาช้าง', vi: 'Xám voi', id: 'Abu-abu gajah' },
};

/** 常见省略写法 → 标准中文名 */
const COLOR_ALIASES = {
  黑: '黑色',
  白: '白色',
  米白: '米白色',
  奶白: '奶白色',
  灰: '灰色',
  深灰: '深灰色',
  浅灰: '浅灰色',
  红: '红色',
  酒红: '酒红色',
  粉: '粉色',
  玫红: '玫红色',
  橙: '橙色',
  黄: '黄色',
  绿: '绿色',
  军绿: '军绿色',
  墨绿: '墨绿色',
  蓝: '蓝色',
  深蓝: '深蓝色',
  浅蓝: '浅蓝色',
  天蓝: '天蓝色',
  藏青: '藏青色',
  藏蓝: '藏青色',
  藕粉: '藕粉色',
  香芋紫: '香芋紫',
  雾霾蓝: '雾霾蓝',
  湖蓝: '湖蓝色',
  牛仔蓝: '牛仔蓝',
  荧光绿: '荧光绿',
  枣红: '枣红色',
  奶黄: '奶黄色',
  大象灰: '大象灰',
  紫: '紫色',
  棕: '棕色',
  咖: '咖啡色',
  咖啡: '咖啡色',
  卡其: '卡其色',
  杏: '杏色',
  驼: '驼色',
  金: '金色',
  银: '银色',
  香槟: '香槟色',
  花: '花色',
};

const SPEC_COLOR_EN = {
  均码: 'One size',
};

function localeKey() {
  const raw = String(i18n.resolvedLanguage || i18n.language || 'zh-CN');
  if (raw.toLowerCase().startsWith('pt')) return 'pt-BR';
  const base = raw.split('-')[0];
  return COLOR_NAMES.黑色[base] ? base : 'en';
}

function normalizeToken(raw) {
  const token = String(raw || '').trim();
  if (!token) return '';
  return COLOR_ALIASES[token] || token;
}

function translateToken(token, lang) {
  const canonical = normalizeToken(token);
  const names = COLOR_NAMES[canonical];
  if (names) return names[lang] || names.en;
  if (SPEC_COLOR_EN[canonical]) return SPEC_COLOR_EN[canonical];
  return fixedUi(token);
}

/** 中文颜色名 → 当前语言（中文界面原样返回）；支持「黑色/白色」等多值。 */
export function localizedColorLabel(raw) {
  const text = String(raw ?? '').trim();
  if (!text) return text;
  const lang = String(i18n.resolvedLanguage || i18n.language || '');
  if (lang.toLowerCase().startsWith('zh')) return text;
  const key = localeKey();
  return text
    .split(/[/、,，]|拼/)
    .map((part) => translateToken(part, key))
    .filter(Boolean)
    .join(' / ');
}

/** 反查：当前语言的颜色名 → 存库用的中文名（找不到则原样返回）。 */
export function canonicalColorLabel(raw) {
  const text = String(raw ?? '').trim();
  if (!text) return text;
  const lower = text.toLowerCase();
  const hit = Object.keys(COLOR_NAMES).find((zh) => (
    Object.values(COLOR_NAMES[zh]).some((value) => String(value).toLowerCase() === lower)
  ));
  return hit || text;
}
